import { createEffect, createStore, sample } from 'effector'
import { TColumnOfPaidServicesForKanban, TFilterOfPaidService } from './types'
import { TErrorResponse, TResponse } from '../types'
import api from '../../Auth/api'
import { PaidServiceStageIds } from '../../common/types/paidService'

//Попросили сделать сортировку на фронте
// Определение
// Калькуляция - необходимость
// Калькуляция - подготовка
// Калькуляция - проверка
// Счёт
// Проектирование договора на оказание услуг
// Получение скана подписанного договора
// Выполнение работ
// Корректировка калькуляции - подготовка
// Корректировка калькуляции - проверка
// Доп счёт
// УПД

type TGetPaidServicesForKanbanFxResponse = TResponse<
  TColumnOfPaidServicesForKanban[]
>

export const $paidServicesForKanban = createStore<
  TColumnOfPaidServicesForKanban[] | null
>(null)

export const getPaidServicesForKanbanFx = createEffect<
  Partial<TFilterOfPaidService> | void,
  TGetPaidServicesForKanbanFxResponse,
  TErrorResponse
>((data) => api.post('paid-service/kanban', data))

sample({
  clock: getPaidServicesForKanbanFx.doneData,
  fn: (res) => {
    const kanban = res.data.data
    const kanbanWithCorrectSorting: any = [...kanban]
    // kanbanWithCorrectSorting[]
    kanbanWithCorrectSorting[5] = kanban.find(
      (item) => item.type_id === PaidServiceStageIds.WAITING_PAYMENT
    )
    kanbanWithCorrectSorting[6] = kanban.find(
      (item) =>
        item.type_id ===
        PaidServiceStageIds.DRAFTING_CONTRACT_FOR_SPECIFYING_SERVICES
    )
    kanbanWithCorrectSorting[7] = kanban.find(
      (item) => item.type_id === PaidServiceStageIds.GET_SCAN_OF_SIGNED_CONTRACT
    )
    kanbanWithCorrectSorting[8] = kanban.find(
      (item) => item.type_id === PaidServiceStageIds.COMPLETING_WORK
    )
    kanbanWithCorrectSorting[9] = kanban.find(
      (item) =>
        item.type_id === PaidServiceStageIds.CORRECT_CALCULATION_PREPARATION
    )
    kanbanWithCorrectSorting[10] = kanban.find(
      (item) => item.type_id === PaidServiceStageIds.CORRECT_CALCULATION_CHECK
    )
    kanbanWithCorrectSorting[11] = kanban.find(
      (item) => item.type_id === PaidServiceStageIds.ADDITIONAL_CHECK
    )
    kanbanWithCorrectSorting[12] = kanban.find(
      (item) => item.type_id === PaidServiceStageIds.UPD
    )
    return kanbanWithCorrectSorting
  },
  target: $paidServicesForKanban
})
